// Case gallery slider
var splide = new Splide( '#gallery',{
    //padding: '2rem',
    trimSpace: false,
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: true,
    gap: '2.5rem',
    arrowPath: 'M0 7.00008V9.00008H12L6.5 14.5001L7.92 15.9201L15.84 8.00008L7.92 0.0800781L6.5 1.50008L12 7.00008H0Z',

    breakpoints: {
        1280: {
            perPage: 1,
        },
        860: {
            perPage: 1,
        },
        580: {
            perPage: 1,
        },
    },

    classes: {
        arrows: 'splide__arrows flex gap-4',
        arrow : 'splide__arrow items-center bg-pink-400 w-[63px] h-[63px]',
        prev  : 'splide__arrow--prev left-1',
        next  : 'splide__arrow--next right-1',
        // Add classes for pagination.
        pagination: 'splide__pagination !block !top-0 !right-0', // container
        page      : 'splide__pagination__page !w-[3.125rem] !h-[0.3rem] rounded-sm', // each button
    },

} ).mount();

let currentIndex = splide.index + 1; // index starts from 0
let totalSlides = splide.length;

slidecount.innerHTML = `${currentIndex}/${totalSlides}`;

splide.on( 'move', () => {
    let currentIndex = splide.index + 1; // index starts from 0
    let totalSlides = splide.length;

    slidecount.innerHTML = `${currentIndex}/${totalSlides}`;

} );